import {
  keepPreviousData,
  useQuery,
  type UseQueryOptions,
} from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import PluginService from 'services/PluginService';
import { PLUGINS } from 'queries/query-keys';
import { getChosenBusiness } from 'store/authentication/selectors';
import type { BusinessApp } from './types';

type BusinessAppsOptions = Pick<
  UseQueryOptions<BusinessApp[]>,
  'enabled' | 'staleTime' | 'throwOnError'
>;

// Options the caller omits stay off the object: the query client spreads these
// over its defaults, so an explicit `undefined` would override them.
export const businessAppsQueryOptions = (
  businessId: string,
  search: string,
  { enabled = true, staleTime = 0, ...rest }: BusinessAppsOptions = {}
): UseQueryOptions<BusinessApp[]> => ({
  queryKey: PLUGINS.GET_BUSINESS_APPS(search),
  queryFn: () => PluginService.getBusinessApps(businessId, search),
  placeholderData: keepPreviousData,
  staleTime,
  enabled,
  ...rest,
});

export const useBusinessApps = (
  search: string,
  options: BusinessAppsOptions = {}
) => {
  const business = useSelector(getChosenBusiness);
  return useQuery<BusinessApp[]>(
    businessAppsQueryOptions(business.id, search, options)
  );
};
